module.exports = __webpack_public_path__ + "img/fisher-icon-meetings.5ab2fd7f.svg";